// extracted by mini-css-extract-plugin
export var container = "_7g-0";
export var fallback = "_7g-5";
export var fallbackIcon = "_7g-6";
export var hidden = "_7g-2";
export var image = "_7g-3";
export var loaded = "_7g-4";
export var placeholder = "_7g-1";